export type UserLocation = {
  lat: number;
  lon: number;
  accuracy: number;
  timestamp: number;
};

export const getUserLocation = (): Promise<UserLocation> =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("No geolocation"));

    navigator.geolocation.getCurrentPosition(
      (position) =>
        resolve({
          lat: position.coords.latitude,
          lon: position.coords.longitude,
          accuracy: position.coords.accuracy ?? 999999,
          timestamp: position.timestamp ?? Date.now(),
        }),
      reject,
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 10_000 }
      
    );
  });
